module.exports = __webpack_public_path__ + "static/img/23.885c56a.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/articleProject/images/qlxj/23.png
// module id = G3BR
// module chunks = 6